import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageSwitcherComponent } from './components/language-switcher/language-switcher.component';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ContentBoxComponent } from './components/content-box/content-box.component';
import { LoaderComponent } from './components/loader/loader.component';
import { FlatLayoutWrapperComponent } from './components/flat-layout-wrapper/flat-layout-wrapper.component';
import { ContentLayoutComponent } from './components/content-layout/content-layout.component';
import { ContentLayoutWrapperComponent } from './components/content-layout-wrapper/content-layout-wrapper.component';
import { FlatLayoutComponent } from './components/flat-layout/flat-layout.component';
import { MainLayoutWrapperComponent } from './components/main-layout-wrapper/main-layout-wrapper.component';
import { ContentLogoComponent } from './components/content-logo';

@NgModule({
  declarations: [
    MainLayoutWrapperComponent,
    LanguageSwitcherComponent,
    ContentBoxComponent,
    LoaderComponent,
    ContentLogoComponent,

    FlatLayoutWrapperComponent,
    FlatLayoutComponent,
    ContentLayoutWrapperComponent,
    ContentLayoutComponent,
  ],
  imports: [CommonModule, DropdownModule, FormsModule, ProgressSpinnerModule, RouterOutlet],
  exports: [
    FlatLayoutWrapperComponent,
    FlatLayoutComponent,
    ContentLayoutWrapperComponent,
    ContentLayoutComponent,
    ContentLogoComponent,
    ContentBoxComponent,
  ],
})
export class LayoutModule {}
